/*
  FOR NODE ENVIRONMENT ONLY

  Our token .json files are bundled by rspack as ESM modules (see
  scripts/jsonDefaultExportLoader.cjs: `export default <obj>` + named consts for
  the identifier-safe top-level keys). When one of the Node-only tailwind helper
  files does a CommonJS `require()` of such a JSON *inside the rspack bundle*,
  it receives the ESM namespace object, not the JSON itself:

    { __esModule: true, default: <full object>, below: 0, base: 0, ... }

  Two problems with using that namespace directly:
    - the full object lives on `.default`, while the namespace only carries the
      identifier-safe keys — so kebab-case keys (e.g. zIndexes `modal-below`,
      `alert-above`) are missing entirely;
    - it carries an extra enumerable `default` key, which leaks into anything
      that iterates with `for..in` / `Object.entries` (e.g. a bogus
      `--c-default` color or `c-z-default` utility).

  Native Node `require()` of the same JSON (how tailwind.config.js loads these
  at runtime) returns the plain object directly. This unwraps both shapes so
  callers always get the complete, untouched token object.
*/
module.exports = (mod) => (mod?.__esModule ? mod.default : mod)
